import { CloseCircleOutlined } from '@ant-design/icons';
import { ProFormColumnsType } from '@ant-design/pro-form';
import { ColProps, FormInstance, Tag, Tooltip, Input } from 'antd';
import { isInvalidEmail } from 'utils';
import AccessList from './AccessList';
import styles from './Invite.module.less';
import { DataItem, InviteFormProps, TagProp } from './typings';
import useInviteStore from './useInviteStore';

const { TextArea } = Input;
const colProps24: ColProps = { xs: 24, sm: 24, md: 24, lg: 24 };
const EmailTag = ({ prop }: TagProp) => {
  const { label, closable, onClose } = prop;
  return (
    <Tag
      {...prop}
      key={String(`key${label}`)}
      color={isInvalidEmail(String(label)) ? 'error' : 'default'}
      icon={
        isInvalidEmail(String(label)) && (
          <Tooltip placement="bottom" title="Invalid Email">
            <CloseCircleOutlined />
          </Tooltip>
        )
      }
      closable={closable}
      onClose={onClose}
      className={styles.emailtag}
    >
      {label}
    </Tag>
  );
};
const InviteFormFields = ({
  t,
  userPermissionsList,
  onRemoveUser,
  onAssignRole,
  isUsersListLoading,
}: InviteFormProps): ProFormColumnsType<DataItem>[] => {
  const emails = useInviteStore((state) => state.emails);
  const setEmails = useInviteStore((state) => state.setEmails);
  return [
    {
      dataIndex: 'emails',
      initialValue: [],
      valueType: 'select',
      fieldProps: (form: FormInstance<DataItem>) => ({
        mode: 'tags',
        placeholder: 'Add Employee Emails',
        onChange: (value: DataItem['emails']) => {
          setEmails(value);
          form?.setFieldsValue({ emails: value });
        },
        tokenSeparators: [',', ' ', ';'],
        tagRender: (tagProps) => <EmailTag prop={tagProps} t={t} />,
        notFoundContent: null,
        style: {
          marginBottom: '8px',
        },
      }),
      colProps: colProps24,
    },
    {
      dataIndex: 'Value',
      valueType: 'text',
      renderFormItem: () =>
        emails?.length === 0 ? null : (
          <div style={{ marginTop: '8px' }}>
            <TextArea className={styles.textinput} rows={7} placeholder="Add Message" />
          </div>
        ),
      fieldProps: {
        placeholder: 'Add Message',
      },
    },
    {
      dataIndex: 'access',
      hideInForm: emails?.length !== 0,
      renderFormItem: () => (
        <AccessList
          userPermissionsList={userPermissionsList}
          onRemoveUser={onRemoveUser}
          onAssignRole={onAssignRole}
          isUsersListLoading={isUsersListLoading}
        />
      ),
    },
  ];
};
export default InviteFormFields;
